import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { getRouteFromLoanStageService } from "../../shared/services/getRouteFromLoanStageService";
import { useLocation } from "react-router-dom";

const CarouselWrapper = styled.div`
	.floating {
		position: absolute;
		top: 18rem;
		z-index: 1;
		display: flex;
		flex-direction: column;
		gap: 0.5rem;
	}

	.apply-btn {
		position: relative;
		${'' /* width: fit-content; */}
		margin-left: 0.5rem;
	}

	.apply-btn > button {
		padding: 0.25rem 2.5rem;
		border-radius: 0.5rem;
		border: none;
		color: white;
		background-color: #d4ae69;
		font-size: 1.4rem;
		// margin-top: 40%;
	}

	.index-carousel-message {
		width: 60%;
		padding: 0.7rem;
		border-radius: 0 1rem 1rem 0;
		font-size: 1.4rem;
		// background-color: #c7222a;
		color: white;
	}

	.carousel-main {
		height: 250px;
		overflow: hidden;
		display: flex;
	}

	.carousel-img-container {
		position: relative;
		width: 100%;
		height: fit-content;
		/* transform: translateX(-50vw); */
		transition: all 550ms ease-in-out;
	}

	.carousel-img-container > div {
		width: 60vw;
		height: 30vmax;
		background-repeat: no-repeat;
		background-size: cover;
		background-postion: center;
		position: relative;
	}

	.carousel-buttons {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		gap: 0.5rem;
		margin: 0 1.5rem;
		position: relative;
		bottom: 3rem;
		z-index: 2;
		overflow: hidden;
	}

	.carousel-buttons > div {
		height: 1rem;
		width: 1rem;
		border-radius: 100%;
		background-color: white;
	}

	@media only screen and (max-width: 768px) {
		.carousel-img-container > div {
			width: 100vw;
			height: 250px;
		}
	}
`;

// const Carousel = ({ images, carouselMessage, index = 0 }) => {
const Carousel = ({ images, index = 0, navigate, source, customerDetails }) => {
	const [currentIndex, setCurrentIndex] = useState(index);
	const [width, setWidth] = useState(0);
	const [offset, setOffset] = useState("");
	const carouselMain = useRef(null);
	const location = useLocation();
	const searchParams = new URLSearchParams(location.search);
	const [urlParams, setUrlParams] = useState("");

	useEffect(() => {
		setUrlParams(window.location.search);
	}, []);

	useEffect(() => {
		setWidth(carouselMain.current.offsetWidth);
		// console.log("Width: ", width);
	}, []);

	useEffect(() => {
		setOffset(`${currentIndex * 100}%`);
	}, [currentIndex]);

	function applyLoan() {
		var route = getRouteFromLoanStageService({
			source: source,
			stage: "",
		});
		if (urlParams) {
			const url = `${route}${urlParams}`;
			navigate(url, {
				replace: true,
				state: {
					customerDetails: customerDetails,
				},
			});
		} else {
			const url = `${route}`;
			navigate(url, {
				replace: true,
				state: {
					customerDetails: customerDetails,
				},
			});
		}
	}

	return (
		<>
			<CarouselWrapper len={images.length}>
				<div className="floating">
					<div className="index-carousel-message">
						
					</div>
					<div className="apply-btn">
						<button onClick={applyLoan}>Apply</button>
					</div>
				</div>
				<div className="carousel-main" ref={carouselMain}>
					{images.map((e, i) => {
						return (
							<>
								<div
									className="carousel-img-container"
									style={{ right: offset }}
								>
									{/* <img src={e} /> */}
									<div
										style={{ backgroundImage: `url(${e})` }}
									></div>
								</div>
							</>
						);
					})}
				</div>
				{/* <div className="carousel-buttons">
					{images.map((e, i) => {
						return (
							<>
								<div
									style={{
										backgroundColor:
											i == currentIndex ? `red` : ``,
									}}
									onClick={() => setCurrentIndex(i)}
								></div>
							</>
						);
					})}
				</div> */}
			</CarouselWrapper>
		</>
	);
};

export default Carousel;
